import { queryOptions, useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { generateListResponseScheme, type ListRespondedWith } from '@/models/response';
import { fetcher } from '@/utils/fetcher';

export const countrySchema = z.object({
  CnName: z.string(),
  Code: z.string(),
  EnName: z.string(),
  ID: z.number(),
  TelCode: z.string(),
});

export type Country = z.infer<typeof countrySchema>;

export const countryListQueryOptions = queryOptions({
  queryKey: ['/GetCountryList'],
  queryFn: ({ signal }) =>
    fetcher<ListRespondedWith<Country>>('/GetCountryList', undefined, {
      signal,
      schema: generateListResponseScheme(countrySchema),
      requireAuth: false,
      validResponseCodes: [0],
    }).then((response) => response?.Data ?? []),
  placeholderData: [],
  staleTime: 24 * 60 * 60 * 1000,
});

export default function useCountryList() {
  const query = useQuery(countryListQueryOptions);

  return {
    countryList: query.data ?? [],
    ...query,
  };
}
